module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recommended":"(Recommended)"}}')
  delete Component.options._Ctor
}
